// extracted by mini-css-extract-plugin
export default {"LikeControl__btn":"it_a"};